module.exports = __webpack_public_path__ + "img/pic17.709e1552.jpg";